import { Loading } from 'quasar'

Loading.show({
  ignoreDefaults: true,
  delay: 0,
  backgroundColor: 'transparent',
  spinnerColor: 'primary',
  spinnerSize: 200
})
